const SELF_DIAGNOSIS_SCREEN = "self_diagnosis_screen";
const PAIN_PROFILE_SCREEN = "profile_screen";
const QUESTION_CHANGED_WARNING = "question_changed_warning";
const UNEXPECTED_ERROR = "client_unexpected_error";
const TEMP_LOGIN = "temp_login";
const THINKING = "thinking";
const EXIT_DIAGNOSTIC = "exit_diagnostic";
const CONSENT_MEDICAL = "consent-medical";
const CONSENT_TERMS = "consent-terms";
const CONSENT_PRIVACY = "consent-privacy";
const HUMAN_INFO = "human-info";

export const ModalType = {
  SELF_DIAGNOSIS_SCREEN,
  PAIN_PROFILE_SCREEN,
  UNEXPECTED_ERROR,
  QUESTION_CHANGED_WARNING,
  TEMP_LOGIN,
  THINKING,
  EXIT_DIAGNOSTIC,
  CONSENT_MEDICAL,
  CONSENT_TERMS,
  CONSENT_PRIVACY,
  HUMAN_INFO
};

// Modal types which comes from `/help` endpoint
export const HelpTextTypes = [SELF_DIAGNOSIS_SCREEN, PAIN_PROFILE_SCREEN];

export const ModalTypes = [
  ...HelpTextTypes,
  QUESTION_CHANGED_WARNING,
  UNEXPECTED_ERROR,
  TEMP_LOGIN,
  THINKING,
  EXIT_DIAGNOSTIC,
  CONSENT_MEDICAL,
  CONSENT_TERMS,
  CONSENT_PRIVACY,
  HUMAN_INFO
];



// WEBPACK FOOTER //
// ./src/modules/modal/modal-constants.js